<template>
    <div id="technical_support_request" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area pt-0">
            <template v-if="cantAccessPage === true">
                <div class="page-name pb-1 new-ticket-header">
                    <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                        <div v-if="isEditPage" class="text-left">
                            <span class="page-title" id="purchaseorderHeader" style="width: 100%;">Update Technical
                                Support Ticket</span>
                        </div>
                        <div v-else class="text-left">
                            <button v-on:click.prevent="generateTicketNumber()" class="btn btn-primary"
                                style="padding: 5px 4px; font-size: 1.25rem; font-weight: bold;" :disabled="!canCreateNewTicket">
                                Create New Ticket
                            </button>
                        </div>

                        <div class="text-right">
                            <button type="button" v-if="isEditPage && ticket_status == 'New' && hasFullReadWriteAccess"
                                class="btn btn-primary" v-on:click.prevent="processTicket()">
                                <strong>Process Ticket</strong>
                            </button>
                            <button type="submit" class="btn btn-secondary" v-on:click.prevent="technicalSupportQueue">
                                <i class="fp-back"></i> Back
                            </button>
                        </div>
                    </div>
                    <div class="row" style="padding-left: 2%;margin-top: 10px;">
                        <div class="col header-font"><b>Ticket Number</b>: {{ ticket_number }}</div>
                        <div class="col header-font"><b>VIN</b>: {{ vin.text || '' }}</div>
                        <div class="col header-font"><b>Ticket Creation Date</b>: {{ creation_date }}</div>
                        <div class="col header-font"><b>Days Open</b>: {{ days_open }}</div>
                        <div class="col header-font"><b>Status</b>: {{ ticket_status }}</div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="from-group">
                        <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <strong id="errorMsg" class="field-error"></strong>
                        </div>
                    </div>
                    <div class="admin-page-content customer-crud">
                        <section class="internal-container border-top-table-fl">
                            <div class="col-md-6 col-12 pl-0">
                                <p class="m-0"><strong style="font-size: 18px;">Before You Submit:</strong> <span
                                        style="font-size: 17px;">Please ensure that you have the
                                        following</span></p>
                                <table class="submission-table">
                                  <thead>
                                  <tr>
                                    <th class="pl-4">Label</th>
                                    <th>Description</th>
                                  </tr>
                                  </thead>
                                    <tbody>
                                        <tr>
                                            <td class="pl-4">Freeze Frame Report</td>
                                            <td class="highlight">This must be uploaded to the ticket at time of
                                                submission.</td>
                                        </tr>
                                        <tr>
                                            <td class="pl-4">
                                                HV State of Charge (SOC) <br />
                                                LV Battery Voltage <br />
                                                Has the LV Battery Been Replaced?
                                            </td>
                                            <td>These details can be added to your ticket notes</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <form autocomplete="off" class="needs-validation mt-4" novalidate
                                id="technicalSupportRequestForm">
                                <div class="form-row">
                                    <div class="col-3 form-group">
                                        <label class="control-label require">Dealer Location:</label>
                                        <v-select v-if="loadAllDealers" v-model="dealer_id" name="dealer_id"
                                            label="text" :filterable="false" :options="modifiedDealerArr"
                                            @search="onSearchDealer" @change="handleChange($event, 'dealer_location')"
                                            readonly placeholder="Select Dealer"
                                            class='custom-ci-auto-search close-remove'
                                            :disabled="!isEditPage || disableAllFields">
                                            <template slot="no-options">
                                                Search Dealer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <v-select v-else v-model="dealer_id" name="dealer_id" label="text"
                                            :filterable="false" :options="modifiedDealerArr" readonly
                                            placeholder="Select Dealer" @change="handleChange($event, 'dealer_location')"
                                            class='custom-ci-auto-search close-remove'
                                            :disabled="!isEditPage || disableAllFields">
                                            <template slot="no-options">
                                                Select Dealer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ dealer_location_error_msg }}</div>
                                    </div>
                                    <div class="col-3 form-group">
                                        <label class="control-label" for="dealer_group">Dealer
                                            Group:</label>
                                        <input type="text" disabled class="form-control" v-model.trim="dealer_group"
                                            id="dealer_group" placeholder="Dealer Group" name="dealer_group">
                                        <span class="field-error">{{ dealer_group_error_msg }}</span>
                                    </div>
                                    <div class="col-3 form-group">
                                        <label class="control-label" for="dealer_code">Dealer
                                            Code:</label>
                                        <input type="text" disabled class="form-control" v-model.trim="dealer_code"
                                            id="dealer_code" placeholder="Dealer Code" name="dealer_code">
                                        <span class="field-error">{{ dealer_code_error_msg }}</span>
                                    </div>
                                    <div class="col-3 form-group">
                                        <label class="control-label" for="creation_date">Creation
                                            Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" disabled id="creation_date"
                                                name="creation_date" v-model="creation_date"
                                                :config="optionsDate"></date-picker>
                                            <label for="creation_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <span style="color: red;font-size: 12px;">{{ creation_date_error_msg }}</span>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col-3 form-group">
                                        <label class="control-label" for="ticket_number">Ticket #:</label>
                                        <input type="text" disabled class="form-control" v-model.trim="ticket_number"
                                            id="ticket_number" placeholder="Ticket Number" name="ticket_number">
                                        <span class="field-error">{{ ticket_number_error_msg }}</span>
                                    </div>
                                    <div class="col-3 form-group">
                                        <label class="control-label" for="last_modification">Last
                                            Modification:</label>
                                        <input type="text" disabled class="form-control"
                                            v-model.trim="last_modification" id="last_modification"
                                            placeholder="Last Modification" name="last_modification">
                                        <span class="field-error">{{ last_modification_error_msg }}</span>
                                    </div>
                                    <div class="col-3 form-group">
                                        <label class="control-label" for="days_open">Days Open:</label>
                                        <input type="text" disabled class="form-control" v-model.trim="days_open"
                                            id="days_open" placeholder="Days Open" name="days_open">
                                        <span class="field-error">{{ days_open_error_msg }}</span>
                                    </div>
                                    <div class="col-3 form-group">
                                        <label class="control-label" for="status">Ticket Status:</label>
                                        <v-select v-model="ticket_status" name="status"
                                            placeholder="Select Ticket Status"
                                            @change="handleChange($event, 'ticket_status')" label="text"
                                            :options="ticketStatusArr" disabled>
                                        </v-select>
                                        <div class="field-error">{{ ticket_status_error_msg }}</div>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col-3 form-group">
                                        <label class="control-label require">Full VIN:</label>
                                        <v-select v-model="vin" id="vin" name="vin" label="text" :filterable="false"
                                            :options="vinArr" @search="onSearchAssetWithVin"
                                            placeholder="Search Vehicle with Vin"
                                            class='custom-ci-auto-search close-remove'
                                            @change="handleChange($event, 'vin')"
                                            :disabled="!isEditPage || disableAllFields">
                                            <template slot="no-options">
                                                Search Vehicle with Vin...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ vin_error_msg }}</div>
                                    </div>
                                    <div class="col-3 form-group">
                                        <label class="control-label require" for="odometer">Odometer:</label>
                                        <input type="number" class="form-control" v-model.trim="odometer" id="odometer"
                                            placeholder="Odometer" name="odometer" @keypress="isNumber($event)"
                                            :disabled="!isEditPage || disableAllFields">
                                        <span class="field-error">{{ odometer_error_msg }}</span>
                                    </div>
                                    <div class="col-3 form-group">
                                        <label class="control-label require" for="vehicle-system">Vehicle
                                            System:</label>
                                        <v-select v-model="vehicle_system" name="vehicle_system"
                                            placeholder="Select Vehicle System" label="text" :options="vehicleSystemArr"
                                            @change="handleChange($event, 'vehicle_system')"
                                            :disabled="!isEditPage || disableAllFields">
                                        </v-select>
                                        <div class="field-error">{{ vehicle_system_error_msg }}</div>
                                    </div>
                                    <div class="col-3 form-group">
                                        <label class="control-label require" for="dealer_ro_number">Dealer RO #:</label>
                                        <input type="text" class="form-control" v-model.trim="dealer_ro_number"
                                            id="dealer_ro_number" placeholder="Dealer RO #" name="dealer_ro_number"
                                            :disabled="!isEditPage || disableAllFields">
                                        <span class="field-error">{{ dealer_ro_number_error_msg }}</span>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col-6 form-group">
                                        <label class="control-label" for="created_by">Created By:</label>
                                        <div class="d-flex">
                                            <input type="text" disabled class="form-control col-6"
                                                v-model.trim="created_by_name" id="created_by_name"
                                                placeholder="User Name" name="created_by">
                                            <input type="text" disabled class="form-control col-6 ml-1"
                                                v-model.trim="created_by_email" id="created_by_email"
                                                placeholder="User Email" name="created_by">
                                        </div>
                                        <span class="field-error">{{ created_by_error_msg }}</span>
                                    </div>
                                    <div class="col-3 form-group">
                                        <label class="control-label require" for="phone_no">Phone:</label>
                                        <input type="text" class="form-control"
                                            v-cleave="{ delimiter: '-', blocks: [3, 3, 4] }" v-model="phone"
                                            id="phone_no" placeholder="999-999-9999" name="phone_no"
                                            @keypress="isNumber($event)" ref="phoneInput"
                                            :disabled="!isEditPage || disableAllFields">
                                        <span class="field-error">{{ phone_error_msg }}</span>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col-3 form-group">
                                        <div class="d-flex align-items-center justify-content-between mb-1">
                                            <label class="control-label" for="pwa_number">PWA#:</label>
                                            <a 
                                                @click="scrollToPwaSection($event)" 
                                                class="btn-primary pl-2 pr-2 rounded pt-1 pb-1" 
                                                type="button" 
                                                v-if="isRizonRep"
                                                :style="{
                                                    color: 'white',
                                                    fontSize: '12px',
                                                    cursor: disablePwaAddButton ? 'not-allowed' : 'pointer',
                                                    opacity: disablePwaAddButton ? '0.65' : '1',
                                                }"
                                            >
                                                <strong>Add PWA</strong>
                                            </a>
                                        </div>
                                        <input type="text" class="form-control" v-model.trim="pwa_number"
                                            id="pwa_number" placeholder="PWA #" name="pwa_number"
                                            :disabled="true">
                                        <span class="field-error">{{ pwa_number_error_msg }}</span>
                                    </div>
                                    <div class="col-3 form-group">
                                        <label class="control-label" for="assigned-to">Assigned To:</label>
                                        <v-select v-model="assigned_to" multiple name="assigned_to" label="text"
                                                :filterable="false"
                                                :options="assignedToArr" @search="onSearchAssignedToUser" @change="handleChange($event, 'assigned_to')"
                                                placeholder="Search User" class='custom-ci-auto-search close-remove'
                                                :disabled="!isEditPage || disableRizonFields || !(hasFullReadWriteAccess || loggedInUserIsAssignedTicket)">
                                            <template slot="no-options">
                                                Search User...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ assigned_to_error_msg }}</div>
                                    </div>
                                    <div class="col-3 form-group">
                                        <label class="control-label" for="respond_time">Time to Respond:</label>
                                        <input type="text" disabled class="form-control" v-model.trim="respond_time"
                                            id="respond_time" placeholder="Time to Respond" name="respond_time">
                                        <span class="field-error">{{ respond_time_error_msg }}</span>
                                    </div>
                                </div>
                                <hr class="mb-0">

                                <!-- comment history -->
                                <div class="order-summary mt-1">
                                    <div class="row">
                                        <div class="col-md-12 pl-0">
                                            <div class="bg-white radius-5 pl-3 pr-3 pt-3">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <h4>Communication History</h4>
                                                    <button class="btn btn-primary" type="button"
                                                        v-on:click="openCommentModal('dealer')"
                                                        :disabled="!isEditPage || ticket_status == 'Closed'">
                                                        Add Comment
                                                    </button>
                                                </div>
                                                <template>
                                                    <template v-if="commentArr.length > 0">
                                                        <ul class="comment-box">
                                                            <li v-for="(responses, key) in commentArr">
                                                                <div class="comment-details">
                                                                    <div class="comment-dec">
                                                                        <span class="user">{{
                                                                            responses.createdUser
                                                                        }}</span>
                                                                        <span class="ml-2 comment-time">{{
                                                                            responses.comment_date
                                                                        }}</span>
                                                                    </div>
                                                                    <p class="mb-1">{{ responses.comment }}</p>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </template>
                                                    <template v-else>
                                                        <p class="no-data"> No comment available </p>
                                                    </template>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr class="mb-0">

                                <!-- attachments section -->
                                <div class="d-flex align-items-center justify-content-between mt-4 mb-1 pr-3">
                                    <h4>Upload Files</h4>
                                    <button class="btn btn-primary" type="button" v-on:click="addAttachments()"
                                        :disabled="!isEditPage || disableAllFields">
                                        Add Attachment
                                    </button>
                                </div>
                                <div class="table-responsive-sm table-mt-10">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" style="width: 3%;">#</th>
                                                <th scope="col" style="width: 15%;">Attachment Type</th>
                                                <th scope="col" style="width: 25%;">File Description</th>
                                                <th scope="col" style="width: 15%;">Upload Attachment</th>
                                                <th scope="col" style="width: 5%;">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="attachmentRows.length > 0">
                                                <template v-for="(row, index) in attachmentRows">
                                                    <tr :key="index">
                                                        <td>
                                                            {{ index + 1 }}
                                                        </td>
                                                        <td>
                                                            <v-select v-model="row.attachment_type"
                                                                :id="'attachment_type' + index" name="attachment_type"
                                                                placeholder="Select Attachment Type" label="text"
                                                                :options="attachmentTypeArr"
                                                                @change="handleAttachmentTypeChange($event, index)"
                                                                :disabled="disableAllFields">
                                                            </v-select>
                                                            <div v-if="row.attachment_type_error_msg" 
                                                                class="field-error">{{ row.attachment_type_error_msg }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <textarea class="form-control" v-model.trim="row.file_desc"
                                                                rows="2" maxlength="3000" placeholder="File Description"
                                                                :disabled="disableAllFields"></textarea>
                                                            <div v-if="row.file_desc_error_msg" 
                                                                class="field-error">{{ row.file_desc_error_msg }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <template
                                                                v-if="row.file_path == null || row.file_path == ''">
                                                                <input type="file"
                                                                    @change="handleSelectedFile($event, index)"
                                                                    :id="'file_' + index" class="form-control p-0">
                                                                <div v-if="row.file_error_msg" 
                                                                    class="field-error ml-0">{{ row.file_error_msg }}
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                <div class="row">
                                                                    <div class="col d-flex align-items-center">
                                                                        <a v-on:click="goToGetDocumentPath($event, row.file_path)"
                                                                            title="View Dealer Document"
                                                                            href="javascript:void(0);"
                                                                            style="font-size: 15px;">
                                                                            <i class="fp-text-document"></i> Attached
                                                                            File
                                                                        </a>
                                                                        <a v-if="!disableAllFields"
                                                                            href="javascript:void(0);"
                                                                            style="margin-left: 15px;margin-top: 4px;"
                                                                            v-on:click="removeFileLink(index);"
                                                                            class="ms-1">
                                                                            <i class="fp-remove"></i>
                                                                        </a>
                                                                    </div>
                                                                    <div class="col"></div>
                                                                </div>
                                                            </template>

                                                        </td>
                                                        <td class="text-center" style="vertical-align:middle;">
                                                            <template>
                                                                <a v-if="!disableAllFields" title="Remove"
                                                                    href="javascript:void(0);"
                                                                    v-on:click="removeAttachmentRow(index);"> <i
                                                                        class="fp-delete"></i> </a>
                                                                <span v-else>-</span>
                                                            </template>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <tr>
                                                    <td class="text-center" colspan="5" style="color: gray;">
                                                        No data for table
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <div style="color: red;font-size: 12px;" class="ml-0">{{ freeze_frame_report_error_msg }}
                                </div>

                                <div class="btn-groups mt-5">
                                    <button v-if="isEditPage && ticket_status == 'Draft'" type="button"
                                        @click="createSupportTicket('submit')" id="submitTicketBtn"
                                        class="btn btn-primary" :disabled="!isEditPage">
                                        Submit
                                    </button>
                                    <button type="button" @click="createSupportTicket('save-and-close')"
                                        v-if="$route.params.id > 0 && ticket_status == 'Draft'" id="updateTicketBtn"
                                        class="btn btn-primary">
                                        Save and Close
                                    </button>
                                    <button v-if="ticket_status == 'Draft'" type="button" id="clearTicketBtn"
                                        class="btn btn-primary" @click="clearContentsSwal()"
                                        :disabled="!isEditPage && ticket_status == 'Draft'">
                                        Clear Contents
                                    </button>
                                    <button type="button" @click="closeTicket()"
                                        v-if="isEditPage && (hasFullReadWriteAccess || loggedInUserIsAssignedTicket) && ticket_status !== 'Closed'"
                                        id="cancelTicketBtn" class="btn btn-primary" :disabled="!isEditPage">
                                        Close Ticket
                                    </button>
                                </div>
                            </form>
                        </section>

                        <!-- RIZON INTERNAL SECTION -->
                        <section v-if="isRizonRep" class="internal-container border-top-table-fl">
                            <h4><strong>Rizon Internal</strong></h4>
                            <div class="form-row">
                                <div class="col-3 form-group">
                                    <label class="control-label" for="tar_number">TAR #:</label>
                                    <input type="text" class="form-control" v-model.trim="tar_number" id="tar_number"
                                        placeholder="TAR #" name="tar_number"
                                        :disabled="(!isEditPage || disableRizonFields) || !(hasFullReadWriteAccess || loggedInUserIsAssignedTicket)">
                                    <span class="field-error">{{ tar_number_error_msg }}</span>
                                </div>
                                <div class="col-3 form-group">
                                    <label class="control-label" for="creation_date">TAR
                                        Date:</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY"
                                            :disabled="(!isEditPage || disableRizonFields) || !(hasFullReadWriteAccess || loggedInUserIsAssignedTicket)"
                                            id="tar_date" name="tar_date"
                                            v-model="tar_date" :config="optionsDate"></date-picker>
                                        <label for="tar_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <span class="field-error">{{ tar_date_error_msg }}</span>
                                </div>
                            </div>
                            <hr class="mb-0">

                            <!-- PWA creation section -->
                            <div id="pwa-section" class="mt-2">
                                <h4 class="mt-1"><strong>PWA</strong></h4>
                                <div class="form-row">
                                    <div v-show="!pwa_number" class="mr-2" style="margin-top: 18px;">
                                        <button @click="generatePWANumber()" class="btn-primary p-2" 
                                            style="border-radius: 50%; width: 35px; height: 35px;"
                                            title="Generate PWA Number"
                                            :disabled="(!isEditPage || disableRizonFields) || !(hasFullReadWriteAccess || loggedInUserIsAssignedTicket)">
                                            <i class="fa fa-plus" style="font-size: 21px;"></i></button>
                                    </div>
                                    <div class="col-3 form-group">
                                        <label class="control-label" for="pwa_number">PWA Number:</label>
                                        <input type="text" class="form-control" v-model.trim="pwa_number"
                                            id="pwa_number" placeholder="PWA Number" name="pwa_number"
                                            :disabled="true">
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label" :class="pwa_number != '' ? 'require' : ''" for="pwa_desc">PWA Description:</label>
                                        <textarea class="form-control" rows="1" maxlength="3000" 
                                            name="pwa_desc" id="pwa_desc" v-model.trim="pwa_desc" 
                                            placeholder="Description"
                                            :disabled="(!isEditPage || disableRizonFields) || !(hasFullReadWriteAccess || loggedInUserIsAssignedTicket)"></textarea>
                                        <div v-if="pwa_desc_error_message" 
                                            class="field-error">{{ pwa_desc_error_message }}
                                        </div>
                                    </div>
                                    <div class="col-3 form-group">
                                        <label class="control-label" for="pwa_create_date">PWA Create Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" disabled id="pwa_create_date"
                                                name="pwa_create_date" v-model="pwa_create_date"
                                                :config="optionsDate"></date-picker>
                                            <label for="pwa_create_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <DropZone ref="dropzoneComponentRef" 
                                        :uniqueRef="'dropzoneInstance'" :showDropzone="dropZonePreviewFiles.length == 0" 
                                        :showUploadedFiles="dropZonePreviewFiles.length > 0 && isEditPage" 
                                        :maxFileLimit='1' :docErrorMsg="doc_error_msg"
                                        :dropzoneRequired="pwa_number != ''" 
                                        :dropZonePreviewFiles="dropZonePreviewFiles"
                                        @dropzone-update-files="updateFiles" 
                                    />
                                    <div class="col-3 form-group">
                                        <label class="control-label" for="pwa_created_by">Created By:</label>
                                        <input type="text" class="form-control" v-model.trim="pwa_created_by"
                                            id="pwa_created_by" placeholder="Created By" name="pwa_created_by"
                                            :disabled="true">
                                    </div>
                                </div>
                            </div>
                            <hr class="mb-0">

                            <!--rizon comment history -->
                            <div class="order-summary mt-1">
                                <div class="row">
                                    <div class="col-md-12 pl-0">
                                        <div class="bg-white radius-5 pl-3 pr-3 pt-3">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <h4>Rizon Internal Communication History</h4>
                                                <button class="btn btn-primary" type="button"
                                                    v-on:click="openCommentModal('rizon')"
                                                    :disabled="!isEditPage || ticket_status == 'Closed'">
                                                    Add Comment
                                                </button>
                                            </div>
                                            <template>
                                                <template v-if="rizonCommentArr.length > 0">
                                                    <ul class="comment-box">
                                                        <li v-for="(responses, key) in rizonCommentArr">
                                                            <div class="comment-details">
                                                                <div class="comment-dec">
                                                                    <span class="user">{{
                                                                        responses.createdUser
                                                                        }}</span>
                                                                    <span class="ml-2 comment-time">{{
                                                                        responses.comment_date
                                                                        }}</span>
                                                                </div>
                                                                <p class="mb-1">{{ responses.comment }}</p>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </template>
                                                <template v-else>
                                                    <p class="no-data"> No comment available </p>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="btn-groups mt-3">
                                <button @click="createSupportTicket('rizon-save')" type="button"
                                    :disabled="(!isEditPage || disableRizonFields) || !(hasFullReadWriteAccess || loggedInUserIsAssignedTicket)" id="saveRizonBtn"
                                    class="btn btn-primary">
                                    Save
                                </button>
                                <button @click="showCancelSwal()" type="button"
                                    :disabled="(!isEditPage || disableRizonFields) || !(hasFullReadWriteAccess || loggedInUserIsAssignedTicket)" id="cancelRizonBtn"
                                    class="btn btn-primary">
                                    Cancel
                                </button>
                            </div>
                        </section>
                    </div>
                </div>
                <!-- add comment modal -->
                <div class="modal fade policy-modal" id="addCommentModal" ref="addCommentModal" data-backdrop="static"
                    data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">New Comment</h5>
                            </div>
                            <div class="modal-body">
                                <textarea class="form-control" v-model.trim="new_comment" rows="3" maxlength="3000"
                                    placeholder="Write comment"></textarea>
                                <div class="col-md-12 mt-0 pr-0 text-right">
                                    <span>{{ new_comment_chars_count }}/3000</span>
                                </div>
                                <span v-if="new_comment_error_msg" class="field-error">{{
                                    new_comment_error_msg
                                }}</span>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-primary" type="button" v-on:click="addComment()">Submit
                                </button>
                                <button class="btn btn-tertiary" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import { commonMixins } from '../../mixins/commonMixins';
import { contractMixins } from '../../mixins/contractMixins';
import moment from 'moment';
import EventBus from "../event-bus";

import DropZone from '../DropZone.vue';


export default {
    name: "TechnicalSupportRequest",
    components: {
        DropZone,
    },
    metaInfo() {
        return {
            title: (this.isEditPage == true) ? "Update Technical Support Request | " + process.env.COPYRIGHT_NAME : "Create Technical Support Request | " + process.env.COPYRIGHT_NAME
        }
    },
    mixins: [commonMixins, contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading: false,
        isEditPage: false,
        loadAllDealers: false,
        isRizonRep: false,
        supportId: 0,
        userObj: '',
        dealerArr: [],
        modifiedDealerArr: [],
        dealer_id: '',
        dealer_location_error_msg: '',
        dealer_group: '',
        dealer_group_error_msg: '',
        dealer_code: '',
        dealer_code_error_msg: '',
        creation_date: '',
        creation_date_error_msg: '',
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        ticket_number: '',
        ticket_number_error_msg: '',
        last_modification: '',
        last_modification_error_msg: '',
        days_open: '',
        days_open_error_msg: '',
        ticket_status: 'Draft',
        ticket_status_error_msg: '',
        ticketStatusArr: [
            'New',
            'Draft',
            'In Process',
            'Closed'
        ],
        vinArr: [],
        vin: '',
        vin_error_msg: '',
        odometer: '',
        odometer_error_msg: '',
        vehicleSystemArr: [
            'Brakes',
            'Cab - Interior & Exterior',
            'Front Axle',
            'HV - Battery',
            'HV - Charging',
            'HV - Control Unit',
            'HV - E-Axle',
            'HV - E-PTO',
            'HV - Inverter',
            'HV - Wiring',
            'HVAC',
            'Low Voltage System',
            'LV - Battery',
            'Suspension',
            'Thermal System'
        ],
        vehicle_system: '',
        vehicle_system_error_msg: '',
        dealer_ro_number: '',
        dealer_ro_number_error_msg: '',
        created_by_name: '',
        created_by_email: '',
        created_by_error_msg: '',
        phone: '',
        phone_error_msg: '',
        pwa_number: '',
        pwa_number_error_msg: '',
        assignedToArr: [
        ],
        assigned_to: '',
        assigned_to_error_msg: '',
        respond_time: '',
        respond_time_error_msg: '',
        commentArr: [],
        new_comment: '',
        new_comment_error_msg: '',
        new_comment_chars_count: 0,
        attachmentRows: [],
        attachmentTypeArr: [
            'Freeze Frame Report',
            'Picture',
            'Inverter Label'
        ],
        attachmentRowsToDelete: [],
        commentFlag: '',
        // rizon internal
        tar_number: "",
        tar_number_error_msg: '',
        tar_date: '',
        tar_date_error_msg: '',
        rizonCommentArr: [],
        disableRizonFields: false,
        // rizon internal end
        disableAllFields: false,
        freeze_frame_report_error_msg: '',
        canCreateNewTicket: false,
        canUpdateNewTicket: true,
        hasFullReadWriteAccess: false,
        loggedInUserIsAssignedTicket: false,
        technicalMapperId: 0,
        pwa_desc: '',
        pwa_desc_error_message: '',
        pwa_create_date: '',
        pwa_created_by: '',
        doc_error_msg: '',
        files: [],
        dropZonePreviewFiles: [],
        creatingPwa: false,
        disablePwaAddButton: false,
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (
                        permissions[i].name === 'ev_create_technical_support'
                        ||
                        permissions[i].name === 'ev_update_technical_support'
                    ) {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name === 'ev_load_all_dealer_dropdown') {
                        self.loadAllDealers = true;
                    }
                    if (permissions[i].name === 'ev_create_technical_support') {
                      self.canCreateNewTicket = true;
                    }
                    if (permissions[i].name === 'ev_update_technical_support') {
                      self.canUpdateNewTicket = true;
                    }
                    if (permissions[i].name === 'ev_full_read_write_technical_support') {
                      self.hasFullReadWriteAccess = true;
                    }
                    if (permissions[i].name === 'ev_can_access_internal_technical_support') {
                      self.isRizonRep = true;
                    }
                }
                self.getDealerLoadData();
            }
        },
        dealerArr: function (arr) {
            if (arr.length > 0) {
                var self = this;
                self.loading = true;

                self.modifiedDealerArr = arr.map(element => ({
                    text: element.name,
                    value: element.value,
                    parentCode: element.parent_code,
                    customerCode: element.code,
                }));

                if (!self.$route.params.id && !self.loadAllDealers) {
                    self.dealer_id = self.modifiedDealerArr[0];
                }

                self.loading = false;
            }
        },
        dealer_id: function (value) {
            if (value) {
                this.dealer_group = value.parentCode;
                this.dealer_code = value.customerCode;
            }
        },
        isRizonRep(value) {
            if(value) {                
                this.updateDisableFields();
            }
        },
        ticket_status(value) {
            this.updateDisableFields();
        },
    },
    mounted: function () {
        var self = this;
        self.getPermissions();

        self.userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (self.$route.params.id !== undefined && self.$route.params.id > 0) {
            self.supportId = self.$route.params.id;
            self.isEditPage = true;
            self.loadTechnicalSupport();
        }
    },
    methods: {
        updateFiles(files) {
            this.files = files;
        },
        updateDisableFields() {
            if (!this.isRizonRep) return;

            const shouldDisableDropzone = !this.isEditPage || ["New", "Closed"].includes(this.ticket_status);
            this.disablePwaAddButton = shouldDisableDropzone || !!(this.pwa_created_by && this.pwa_number);

            this.$nextTick(() => {
                if (
                    this.$refs.dropzoneComponentRef
                    &&
                    this.$refs.dropzoneComponentRef.$refs.dropzoneInstance
                ) {
                    if (shouldDisableDropzone) {
                        this.$refs.dropzoneComponentRef.$refs.dropzoneInstance.disable();
                    } else {
                        this.$refs.dropzoneComponentRef.$refs.dropzoneInstance.enable();
                    }
                }
            });

            if (shouldDisableDropzone) {
                setTimeout(() => {
                    if (
                        this.$refs.dropzoneComponentRef
                        &&
                        this.$refs.dropzoneComponentRef.$refs.dropzoneInstance
                    ) {
                        this.$refs.dropzoneComponentRef.$refs.dropzoneInstance.disable();
                    }
                }, 800);
            }
        },
        scrollToPwaSection(event){
            if(this.disablePwaAddButton) {
                event.preventDefault();
            } else {
                const pwaSection = document.getElementById('pwa-section');
                const headerOffset = document.querySelector('.new-ticket-header').offsetHeight;
                const bodyRect = document.body.getBoundingClientRect().top;
                const elementRect = pwaSection.getBoundingClientRect().top;
                const elementPosition = elementRect - bodyRect;
                const offsetPosition = elementPosition - (headerOffset + 10);

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        },
        showCancelSwal(){
            if(this.creatingPwa) {
                var title = 'Are you sure you want to cancel the creation of this PWA?';
            } else {
                var title = 'Are you sure you want to cancel all unsaved changes?';
            }
            this.$swal({
                title: title,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
            }).then((result) => {
                if (result.value) {
                    this.technicalSupportQueue();
                }
            });
        },
        generatePWANumber(){
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/technical-support/generate-pwa-number/" + self.supportId,
                type: "GET",
                headers: self.ajxHeaders,
                dataType: "json",
                success: (data) => {                    
                    self.loading = false;
                    if (data.status === "success") {
                        self.creatingPwa = true;
                        self.pwa_number = data.content;
                        self.pwa_created_by = self.userObj.username;
                        self.pwa_create_date = moment().format("MM/DD/YYYY");
                    }
                },
                error: (jqXHR, exception) => {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'technical-support-generate-pwa-number');
                }
            });
        },
        onSearchDealer(search, loading) {
            var self = this;
            if (search.length > 2) {
                loading(true);
                self.searchField(loading, search, 'dealer', '');
            }
        },
        getDealerLoadData() {
            if (!this.loadAllDealers) {
                let userObj = JSON.parse(localStorage.getItem("user_obj"));
                this.loadUserDealerMapper(userObj.id);
            }
        },
        onSearchAssetWithVin(search, loading) {
            var self = this;
            if (search.length > 3) {
                if (typeof loading === 'function') {
                    loading(true);
                } else {
                    self.loading = true;
                }
                self.searchField(loading, search, 'vehicle_vin', '');
            }
        },
        onSearchAssignedToUser(search, loading) {
          var self = this;
          if (search.length > 2) {
            if (typeof loading === 'function') {
              loading(true);
            } else {
              self.loading = true;
            }
            self.searchField(loading, search, 'rizon_technical_support_user', '');
          }
        },
        handleChange(newValue, field) {
            switch (field) {
                case 'dealer_location':
                    this.dealer_id = newValue == null || newValue === '' ? '' : newValue;
                    break;
                case 'vin':
                    this.vin = newValue == null || newValue === '' ? '' : newValue;
                    break;
                case 'ticket_status':
                    this.ticket_status = newValue == null || newValue === '' ? '' : newValue;
                    break;
                case 'vehicle_system':
                    this.vehicle_system = newValue == null || newValue === '' ? '' : newValue;
                    break;
                case 'assigned_to':
                    this.assigned_to = newValue == null || newValue === '' ? '' : newValue;
                    break;
                default:
                    console.warn(`Unhandled field: ${field}`);
            }
        },
        openCommentModal(flag) {
            this.new_comment = '';
            this.new_comment_error_msg = '';
            $('#addCommentModal').modal('show');
            this.commentFlag = flag;
        },
        addComment() {
            var self = this;
            var isValid = true;
            self.new_comment_error_msg = "";

            // Validate new comment input
            if (!self.new_comment || self.new_comment.trim() === "") {
                self.new_comment_error_msg = "Comment is required!";
                isValid = false;
            }

            if (isValid) {
                // Show confirmation modal
                self.$swal({
                    title: 'Comments cannot be changed or deleted. Do you want to submit?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, Submit',
                    cancelButtonText: 'No, Cancel',
                    showCloseButton: false,
                }).then((result) => {
                    if (result.value) {
                        // Prepare user full name
                        var userFullName = [self.userObj.first_name, self.userObj.last_name].filter(Boolean).join(' ');

                        // Prepare comment object
                        var commentData = {
                            id: '',
                            comment_by: self.userObj.id,
                            comment_by_name: self.userObj.first_name,
                            createdUser: userFullName,
                            support_ticket_id: self.supportId,
                            comment: self.new_comment.trim(),
                            comment_date: moment().tz('PST8PDT').format('hh:mm A (MM/DD/YYYY)'),
                        };

                        if (self.commentFlag === 'dealer') {
                            self.commentArr.unshift(commentData);
                        } else if (self.commentFlag === 'rizon') {
                            self.rizonCommentArr.unshift(commentData);
                        }

                        // Clear input fields and error messages
                        self.new_comment = "";
                        self.new_comment_error_msg = "";

                        // Save the comment if on edit page
                        if (self.isEditPage) {
                            self.saveComment();
                        }

                        // Hide the modal after submitting
                        $('#addCommentModal').modal('hide');
                    }
                });
            }
        },
        saveComment() {
            var self = this;
            self.loading = true;

            var fields = {
                'supportId': self.supportId,
                'flag': self.commentFlag
            };
            if (self.commentFlag === 'dealer') {
                fields['comments'] = self.commentArr;
            } else {
                fields['comments'] = self.rizonCommentArr;
            }

            $.ajax({
                url: process.env.ROOT_API + "/technical-support/save-comment",
                type: 'POST',
                data: fields,
                headers: self.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'technical-support-save-comment')
                }
            });
        },
        addAttachments() {
            var success = this.validateattachmentRows();
            if (success) {
                this.attachmentRows.push({
                    id: '',
                    attachment_type: '',
                    attachment_type_error_msg: '',
                    file: '',
                    file_error_msg: '',
                    file_path: '',
                    file_desc: '',
                    file_desc_error_msg: ''
                });
            }
        },
        clearAttachmentRowErrorMsg(index) {
            this.freeze_frame_report_error_msg = '';
            this.attachmentRows[index].attachment_type_error_msg = "";
            this.attachmentRows[index].file_desc_error_msg = "";
            this.attachmentRows[index].file_error_msg = "";
        },
        validateattachmentRows(flag = '') {
            let overallSuccess = true;
            let hasFreezeDocs = false;

            for (let i = 0; i < this.attachmentRows.length; i++) {
                let success = true;
                this.clearAttachmentRowErrorMsg(i);

                if (!this.attachmentRows[i].attachment_type) {
                    this.attachmentRows[i].attachment_type_error_msg = "Select Attachment Type";
                    success = false;
                }
                if (!this.attachmentRows[i].file_desc) {
                    this.attachmentRows[i].file_desc_error_msg = "File Description Required";
                    success = false;
                }

                // checking uploaded file size 
                // Get the file from input by ID
                const inputElement = document.getElementById('file_' + i);

                if (inputElement) {
                    // Check if no files are selected
                    if (inputElement.files.length === 0) {
                        this.attachmentRows[i].file_error_msg = "File Required";
                        success = false;
                    } else {
                        const file = inputElement.files[0];

                        // Check if a file is required but not uploaded (if applicable)
                        if (!file && !this.attachmentRows[i].file_path) {
                            this.attachmentRows[i].file_error_msg = "File Required";
                            success = false;
                        }

                        // Validate file size if a new file is uploaded
                        if (file) {
                            const maxSize = 10000000; // 10MB
                            if (file.size > maxSize) {
                                this.attachmentRows[i].file_error_msg = "The file size is too large. Please upload a file smaller than 10MB.";
                                success = false;
                            } else {
                                // Save the file to the row
                                this.attachmentRows[i].file = file;
                            }
                        }
                    }
                }

                // Check if "Freeze Frame Report" is present in attachment_type
                if (
                    this.attachmentRows[i].attachment_type === "Freeze Frame Report"
                ) {
                    hasFreezeDocs = true;
                }

                if (!success) {
                    overallSuccess = false;
                }
            }

            // If flag is "submit" and "Freeze Frame Report" is not present,
            // set an overall error
            if (flag === "submit" && !hasFreezeDocs) {
                overallSuccess = false;
                this.freeze_frame_report_error_msg = "At least one attachment must have the type 'Freeze Frame Report'.";
            }

            return overallSuccess;
        },
        handleSelectedFile(event, index) {
            const file = event.target.files[0];
            this.attachmentRows[index].file_error_msg = '';
            if (file) {
                // Handling file
                const maxSize = 10000000; // 10MB
                if (file.size > maxSize) {
                    this.attachmentRows[index].file_error_msg = "The file size is too large. Please upload a file smaller than 10MB.";
                } else {
                    this.attachmentRows[index].file = file;
                }
            }
        },
        goToGetDocumentPath(event, link) {
            event.preventDefault();
            var self = this;
            var path = link;
            var flag = '';
            var id = 0;
            self.getDocumentPath(id, path, flag);
        },
        removeFileLink(index) {
            this.attachmentRows[index].file_path = '';
        },
        removeAttachmentRow(index) {
            if (this.attachmentRows.length > 0) {
                if (this.attachmentRows[index].id != "") {
                    this.attachmentRowsToDelete.push({
                        id: this.attachmentRows[index].id
                    });
                }
                this.attachmentRows.splice(index, 1);
            }
        },
        handleAttachmentTypeChange(newValue, index) {
            if (newValue == '' || newValue == null) {
                this.attachmentRows[index].attachment_type = '';
            }
        },
        generateTicketNumber() {
            this.createSupportTicket('generateTicketNumber');
        },
        createSupportTicket(flag) {
            var self = this;
            var success = true;
            self.loading = true;

            if ((self.isEditPage && self.ticket_status != "Draft" && !self.isRizonRep) || flag == "submit") {
                success = self.validateDealerSectionFormFields();
            }

            if (self.isEditPage && self.ticket_status != "Draft" && self.isRizonRep) {
                success = self.validateRizonSectionFormFields();
            }

            if (success) {
                if (flag == 'submit') {
                    self.$swal({
                        title: 'Are you sure you want to submit this support ticket?',
                        text: 'Once you submit this ticket you will not be able to make changes.',
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, Submit',
                        cancelButtonText: 'No, Cancel',
                        showCloseButton: false,
                    }).then((result) => {
                        if (result.value) {
                            self.saveApiCall(flag);
                        } else {
                            self.loading = false;
                        }
                    });
                } else if(
                    flag == 'rizon-save' 
                    && 
                    self.pwa_number != '' 
                    && 
                    self.pwa_number != null
                    &&
                    self.creatingPwa
                ) {
                    self.$swal({
                        title: 'Do you want to create the PWA?',
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        showCloseButton: false,
                    }).then((result) => {
                        if (result.value) {
                            self.saveApiCall(flag);
                        } else {
                            self.loading = false;
                        }
                    });
                } else {
                    self.saveApiCall(flag);
                }
            } else {
                self.loading = false;
                self.scrollToError();
            }
        },
        saveApiCall(flag) {
            const formData = this.prepareFieldsForSubmission(flag);

            $.ajax({
                url: process.env.ROOT_API + "/technical-support/create",
                type: "POST",
                data: formData,
                headers: this.ajxHeaders,
                processData: false,
                contentType: false,
                dataType: "json",
                success: (data) => {
                    this.loading = false;
                    if (data.status === "success") {
                        if (flag === 'generateTicketNumber') {
                            this.$router.push({
                                name: 'TechnicalSupportRequestUpdate',
                                params: { id: data.content.id }
                            });
                        }else if(flag === 'save-and-close' || flag === 'submit'){
                          this.technicalSupportQueue();
                        } else if(flag == 'rizon-save'){
                            this.$swal({
                                title: "",
                                text: "Technical Support Request Updated Successfully.",
                                type: "success",
                                showCancelButton: false,
                                confirmButtonText: "Okay",
                                showCloseButton: false,
                            }).then(result => {
                                if (result.value) {
                                    this.technicalSupportQueue();
                                } else if (result.dismiss) {
                                    this.technicalSupportQueue();
                                }
                            });
                        }
                        else {
                            this.clearFields();
                            this.loadTechnicalSupport();
                        }
                    } else {
                        if (data.content.length > 0) {
                            let err = data.content.join("<br>");
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(() => {
                                $(".alert-warning").removeClass("show").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: (jqXHR, exception) => {
                    this.loading = false;
                    this.generateStatusCodeMessage(jqXHR, false, 'technical-support-request');
                }
            });
        },
        prepareFieldsForSubmission(flag = '') {
            // Initialize FormData
            let formData = new FormData();

            // Append all fields as normal data
            formData.append("id", this.supportId);
            formData.append("dealer_id", this.dealer_id && this.dealer_id.value ? this.dealer_id.value : "");
            formData.append("ticket_number", this.ticket_number);
            formData.append("vehicle_id", this.vin && this.vin.value ? this.vin.value : "");
            formData.append("odometer", this.odometer);
            formData.append("vehicle_system", this.vehicle_system);
            formData.append("dealer_ro_number", this.dealer_ro_number);
            formData.append("phone", this.phone);
            formData.append("dealer_comments", this.commentArr);
            formData.append("assigned_to", JSON.stringify(this.assigned_to));
            formData.append("pwa_number", this.pwa_number);
            formData.append("tar_number", this.tar_number);
            formData.append("tar_date", this.tar_date);
            formData.append("rizon_comments", this.rizonCommentArr);

            if (flag == 'submit') {
                formData.append("ticket_status", "New");
            } else {
                formData.append("ticket_status", this.ticket_status);
            }

            // Check if there are attachments, then append them
            if (this.attachmentRows.length !== 0) {
                this.attachmentRows.forEach((attachment, index) => {
                    formData.append(`attachments[${index}][id]`, attachment.id);
                    formData.append(`attachments[${index}][attachment_type]`, attachment.attachment_type);
                    formData.append(`attachments[${index}][file_desc]`, attachment.file_desc);
                    formData.append(`attachments[${index}][file_path]`, attachment.file_path);

                    // Append the file object if it exists
                    if (attachment.file instanceof File) {
                        formData.append(`attachments[${index}][file]`, attachment.file);
                    }
                });
            } else {
                formData.append('attachments', []);
            }
            formData.append("removed_attachments", JSON.stringify(this.attachmentRowsToDelete));

            if (
                this.creation_date == ""
                ||
                this.creation_date == null
            ) {
                formData.append("creation_date", moment().format("MM/DD/YYYY"))
            } else {
                formData.append("creation_date", this.creation_date);
            }

            formData.append("pwa_desc", this.pwa_desc);
            if (
                this.pwa_number
                &&
                (this.pwa_create_date == ""
                ||
                this.pwa_create_date == null)
            ) {
                formData.append("pwa_create_date", moment().format("MM/DD/YYYY"))
            } else {
                formData.append("pwa_create_date", this.pwa_create_date);
            }
            if (this.files.length !== 0) {
                formData.append('pwa_files', this.files);
            } else {
                formData.append('pwa_files', '');
            }

            // Return the FormData object
            return formData;
        },
        validateRizonSectionFormFields() {
            this.clearRizonSectionErrorMessages();
            var success = true;

            if (this.assigned_to == "" || this.assigned_to == null) {
                this.assigned_to_error_msg = "Assigned To is required!";
                success = false;
            }

            if(this.pwa_number != null && this.pwa_number != '') {                
                if(this.pwa_desc == '' || this.pwa_desc == null) {
                    this.pwa_desc_error_message = "Description is required!";
                    success = false;
                }

                if(this.dropZonePreviewFiles.length == 0) {
                    if (this.files.length == 0) {
                        this.doc_error_msg = "Document File is required!";
                        success = false;
                    }
                }
            }

            return success;
        },
        clearRizonSectionErrorMessages() {
            this.pwa_number_error_msg = '';
            this.assigned_to_error_msg = '';
            this.tar_number_error_msg = '';
            this.tar_date_error_msg = '';
            this.pwa_desc_error_message = '';
            this.doc_error_msg = '';
        },
        validateDealerSectionFormFields() {
            this.clearDealerSectionErrorMessages();
            var success = true;
            var attachmentsSuccess = true;

            if (this.dealer_id == "" || this.dealer_id == null) {
                this.dealer_location_error_msg = "Dealer Location is required!";
                success = false;
            }
            if (this.dealer_group == "" || this.dealer_group == null) {
                this.dealer_group_error_msg = "Dealer Group is required!";
                success = false;
            }
            if (this.dealer_code == "" || this.dealer_code == null) {
                this.dealer_code_error_msg = "Dealer Code is required!";
                success = false;
            }
            if (this.ticket_number == "" || this.ticket_number == null) {
                this.ticket_number_error_msg = "Ticket Number is required!";
                success = false;
            }
            if (this.ticket_status == "" || this.ticket_status == null) {
                this.ticket_status_error_msg = "Ticket Status is required!";
                success = false;
            }
            if (this.vin == "" || this.vin == null) {
                this.vin_error_msg = "VIN is required!";
                success = false;
            }
            if (this.odometer == "" || this.odometer == null || this.odometer == 0) {
                this.odometer_error_msg = "Odometer is required!";
                success = false;
            }
            if (this.vehicle_system == "" || this.vehicle_system == null) {
                this.vehicle_system_error_msg = "Vehicle System is required!";
                success = false;
            }
            if (this.dealer_ro_number == "" || this.dealer_ro_number == null) {
                this.dealer_ro_number_error_msg = "Dealer RO # is required!";
                success = false;
            }
            if (this.phone == "" || this.phone == null) {
                this.phone_error_msg = "Phone is required!";
                success = false;
            } else {
                var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                if(!this.phone.match(phoneRE)){
                    this.phone_error_msg = "Please enter valid phone number";
                    success = false;
                }
            }

            attachmentsSuccess = this.validateattachmentRows('submit');

            if (success && attachmentsSuccess) {
                return true;
            } else {
                return false;
            }
        },
        clearDealerSectionErrorMessages() {
            this.dealer_location_error_msg = '';
            this.dealer_group_error_msg = '';
            this.dealer_code_error_msg = '';
            this.creation_date_error_msg = '';
            this.ticket_number_error_msg = '';
            this.last_modification_error_msg = '';
            this.days_open_error_msg = '';
            this.ticket_status_error_msg = '';
            this.vin_error_msg = '';
            this.odometer_error_msg = '';
            this.vehicle_system_error_msg = '';
            this.dealer_ro_number_error_msg = '';
            this.created_by_error_msg = '';
            this.phone_error_msg = '';
            this.respond_time_error_msg = '';

            this.clearAttachmentRowErrorMessages();
        },
        clearAttachmentRowErrorMessages() {
            if (this.attachmentRows.length > 0) {
                for (let i = 0; i < this.attachmentRows.length; i++) {
                    this.attachmentRows[i].attachment_type_error_msg = '';
                    this.attachmentRows[i].file_desc_error_msg = '';
                    this.attachmentRows[i].file_error_msg = '';
                }
            }
        },
        loadTechnicalSupport() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/technical-support/" + self.supportId,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == 'success') {
                        if (
                            data.content.creation_date != null
                            &&
                            data.content.creation_date != ''
                        ) {
                            self.creation_date = data.content.creation_date;
                        } else {
                            self.creation_date = '';
                            self.creation_date_error_msg = 'Generated after the ticket is submitted';
                        }
                        if (data.content.assigned_dealer) {
                            self.dealer_id = {
                                value: data.content.assigned_dealer.id || null,
                                text: data.content.assigned_dealer.name || '',
                                parentCode: data.content.assigned_dealer.parent ? data.content.assigned_dealer.parent.code : '',
                                customerCode: data.content.assigned_dealer.code || ''
                            };
                        } else {
                            self.dealer_id = '';
                        }

                        if (data.content.assigned_vehicle) {
                            self.vin = {
                                value: data.content.assigned_vehicle.id || null,
                                text: data.content.assigned_vehicle.vin || ''
                            };
                        } else {
                            self.vin = '';
                        }

                        self.ticket_number = data.content.ticket_number;
                        self.odometer = data.content.odometer || '';
                        self.vehicle_system = data.content.vehicle_system || '';
                        self.dealer_ro_number = data.content.dealer_ro_number || '';
                        self.created_by_email = data.content.created_by.email;
                        self.created_by_name = data.content.created_by.full_name;
                        self.phone = data.content.phone || '';
                        self.pwa_number = data.content.pwa_number || '';
                        if (data.content.assigned_to[0]) {
                            self.assigned_to = JSON.parse(data.content.assigned_to);
                        } else {
                            self.assigned_to = '';
                        }
                        self.last_modification = data.content.last_modification;
                        self.respond_time = self.addHyphensToTimeFormat(data.content.time_to_respond);
                        self.days_open = data.content.open_days !== null && data.content.open_days !== undefined
                            ? data.content.open_days
                            : '';
                        self.commentArr = data.content.dealer_comments;
                        self.attachmentRows = data.content.attachments;

                        self.rizonCommentArr = data.content.rizon_comments;
                        self.tar_number = data.content.tar_number || '';
                        self.tar_date = data.content.tar_date || '';
                        if (
                            data.content.pwa_create_date != null
                            &&
                            data.content.pwa_create_date != ''
                        ) {
                            self.pwa_create_date = data.content.pwa_create_date;
                        }
                        if (
                            data.content.pwa_created_by
                            &&
                            data.content.pwa_created_by.email
                        ) {
                            self.pwa_created_by = data.content.pwa_created_by.email;
                        }
                        self.pwa_desc = data.content.pwa_desc;
                        if(data.content.pwa_files != undefined && data.content.pwa_files.length > 0) {
                            self.dropZonePreviewFiles = data.content.pwa_files;
                        }

                        self.loggedInUserIsAssignedTicket = data.content.logged_in_user_is_assigned_ticket;
                        self.technicalMapperId = data.content.viewed_mapper_id;
                        self.ticket_status = data.content.ticket_status;
                        
                        self.handleDisabledFields();
                        self.scrollToTop();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.disableAllFields = true;
                    self.disableRizonFields = true;
                    self.ticket_status = "Closed";
                    self.generateStatusCodeMessage(jqXHR, false, 'get-technical-support-detail');
                }
            });
        },
        updateViewedMapperId() {
            var self = this;
            $.ajax({
                url: process.env.ROOT_API + "/technical-support/update-viewed-mapper-id",
                type: "POST",
                data: {
                    technicalId: self.supportId
                },
                headers: {
                    "Accept": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Authorization": "Bearer " + localStorage.getItem("tkn"),
                    "Access-Control-Allow-Headers":
                        "Origin, Content-Type, Authorization,X-Requested-With",
                    "Cache-Control": "no-cache"
                },
                dataType: "json",
                success: function (data) {                    
                    if (data.status == "success") {
                        EventBus.$emit('updateCount', data.content, 'technical');
                    } else {
                        console.log("Error!!");
                    }
                },
                error: function (jqXHR) {
                    self.generateStatusCodeMessage(
                        jqXHR,
                        false,
                        'user-technical-review-update-viewed-mapper-id'
                    )
                }
            })
        },
        handleDisabledFields() {
            if (
                this.ticket_status == 'New'
                ||
                this.ticket_status == 'Closed'
            ) {
                this.disableAllFields = true;
                this.disableRizonFields = true;
            } else if (this.ticket_status == 'In Process') {
                this.disableAllFields = true;
                this.disableRizonFields = false;
            }
        },
        closeTicket() {
            this.loading = true;
            this.$swal({
                title: 'You are about to close this technical support ticket.',
                html: `
                    <p style="text-align: center;">Tickets should only be closed when all concerns have been addressed.</p>
                    <h4 style="font-weight: bold;">Do you want to close this ticket?</h4>
                `,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
            }).then((result) => {
                if (result.value) {
                    this.ticket_status = 'Closed';
                    this.saveApiCall('close');
                } else {
                    this.loading = false;
                }
            });
        },
        processTicket() {
            this.loading = true;
            this.ticket_status = 'In Process';
            if (
              this.technicalMapperId === undefined 
              ||
              !Number.isInteger(this.technicalMapperId) 
              ||
              this.technicalMapperId <= 0
            ) {
              this.updateViewedMapperId();
            }
            this.saveApiCall('process');
        },
        clearContentsSwal() {
            this.$swal({
                title: 'Are you sure you want to clear this ticket?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
            }).then((result) => {
                if (result.value) {
                  this.clearFields();
                }
            });
        },
        clearFields() {
            this.clearDealerSectionErrorMessages();
            this.clearAttachmentRowErrorMessages();

            this.vin = '';
            this.odometer = '';
            this.vehicle_system = '';
            this.dealer_ro_number = '';
            this.phone = '';

            if (this.attachmentRows.length > 0) {
                this.attachmentRows.forEach((row) => {
                    if (row.id != "") {
                        this.attachmentRowsToDelete.push({
                            id: row.id
                        });
                    }
                });
            }

            this.attachmentRows = [];
        },
        technicalSupportQueue() {
            var self = this;
            self.$router.push("/technical-support-queue");
        },
        scrollToError() {
            // Adding a slight delay before processing
            setTimeout(() => {
                const errorFields = document.querySelectorAll('.field-error');
                const headerOffset = document.querySelector('.new-ticket-header').offsetHeight || 0;
                
                for (const errorField of errorFields) {
                    // Check if errorField contains text
                    if (errorField.textContent.trim().length > 0) {
                        // Try to get the input field first
                        let inputField = errorField.parentElement.querySelector('input');
                        
                        // If no input field, check for textarea
                        if (!inputField) {
                            inputField = errorField.parentElement.querySelector('textarea');
                        }

                        // If either input or textarea exists
                        if (inputField) {
                            // Calculate the scroll position with offset
                            const elementPosition = inputField.getBoundingClientRect().top + window.scrollY;
                            const offsetPosition = elementPosition - (headerOffset + 100);
                            
                            // Scroll to the field smoothly with offset
                            window.scrollTo({
                                top: offsetPosition,
                                behavior: 'smooth'
                            });

                            // Apply focus after scroll completes
                            setTimeout(() => {
                                inputField.focus();
                            }, 300); // Adjust the timeout to wait for scroll to complete

                            // Exit the loop after the first error field is processed
                            return;
                        }
                    }
                }
            }, 500); // Initial delay before processing
        },
        addHyphensToTimeFormat(input) {
            if (input && input !== "") {
                // Add a hyphen before each letter followed by a number except the first one
                return input.replace(/([A-Z])(\d)/g, '$1-$2');
            } 
            return input;
        }
    },
};
</script>
<style scoped>
.new-ticket-header {
    position: sticky;
    top: 65px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.header-font {
    font-size: 18px;
}

.text-red {
    color: red;
}

.submission-table {
    width: 100%;
    border-collapse: collapse;
    font-weight: bold;
}

.submission-table th,
.submission-table td {
    border: 1px solid black;
    padding: 2px;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/technicalSupport/TechnicalSupportRequest.vue